import { FormattedMessage } from 'react-intl'

import Icon from '@/components/Tooltip/Icon'

const Trigger = () => (
  <button
    className='d-inline-flex py-2 vst-btn--transparent styled-as-link'
  >
    <Icon />
    <span className="sr-only">
      <FormattedMessage id='digital_license.open_digital_license_dialog' />
    </span>
    <span className="sr-only">
      <FormattedMessage id='common.opens_in_new_window' />
    </span>
  </button>
)

export default Trigger
